<template>
  <div>
    <ts-loading-banner :loading="loadingPreData">
      <form class="form-horizontal mt-3">
        <div class="row">
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-6">
                <fieldset>
                  <legend class="text-black">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.managementDiscount'
                      )
                    }}
                  </legend>
                  <div class="row form-group">
                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-4">
                      <ts-checkbox v-model="model.is_card_discount">
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.discountCard'
                          )
                        }}
                      </ts-checkbox>
                    </div>
                    <div class="col-md-4">
                      <ts-checkbox
                        v-model="model.is_till_further_notice"
                        :disabled="!model.is_card_discount"
                      >
                        {{
                          $t(
                            'school.academic.operation.profile_mgt.studentProfile.untilFurtherNotice'
                          )
                        }}
                      </ts-checkbox>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label
                      class="col-md-3 col-form-label"
                      :class="!model.is_card_discount ? '' : 'required'"
                    >
                      {{
                        $t(
                          'school.academic.operation.profile_mgt.studentProfile.discountRate'
                        )
                      }}
                    </label>
                    <div class="col-md-8">
                      <input
                        :disabled="!model.is_card_discount"
                        type="number"
                        v-model.number="model.card_discount_rate"
                        class="form-control"
                        :class="{
                          'is-invalid': errors.has('card_discount_rate')
                        }"
                      />
                      <div
                        v-if="errors.has('card_discount_rate')"
                        class="invalid-feedback"
                      >
                        {{ errors.first('card_discount_rate') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label
                      class="col-md-3 col-form-label"
                      :class="
                        !model.is_card_discount || model.is_till_further_notice
                          ? ''
                          : 'required'
                      "
                    >
                      {{
                        $t(
                          'school.academic.operation.profile_mgt.studentProfile.discountExpiryDate'
                        )
                      }}
                    </label>
                    <div class="col-md-8">
                      <ts-date-picker-input
                        :disabled="
                          !model.is_card_discount ||
                            model.is_till_further_notice
                        "
                        v-model="model.discount_expiry_date"
                      />
                      <div
                        v-if="errors.has('discount_expiry_date')"
                        class="validate"
                      >
                        {{ errors.first('discount_expiry_date') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <label class="col-md-3 col-form-label">
                      {{
                        $t(
                          'school.academic.operation.profile_mgt.studentProfile.discountNote'
                        )
                      }}
                    </label>
                    <div class="col-md-8">
                      <textarea
                        :disabled="!model.is_card_discount"
                        type="text"
                        v-model.trim="model.discount_note"
                        class="form-control"
                        :class="{ 'is-invalid': errors.has('discount_note') }"
                        rows="3"
                      ></textarea>
                      <div
                        v-if="errors.has('discount_note')"
                        class="invalid-feedback"
                      >
                        {{ errors.first('discount_note') }}
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div class="col-md-6">
                <fieldset>
                  <legend class="text-black">
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.corporateDiscount'
                      )
                    }}
                  </legend>
                  <div class="row form-group">
                    <label class="col-md-3 col-form-label">
                      {{
                        $t(
                          'school.academic.operation.profile_mgt.studentProfile.corporatePartner'
                        )
                      }}
                    </label>
                    <div class="col-md-8">
                      <ts-search-select
                        v-model.number="model.cpp_id"
                        :options="corporatePartnerOptions"
                      ></ts-search-select>
                      <div v-if="errors.has('cpp_id')" class="validate">
                        {{ errors.first('cpp_id') }}
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
          <div class="col-md-3"></div>
        </div>
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'discount-form',
  props: ['value', 'validate', 'clear'],
  data() {
    return {
      model: {},
      loadingPreData: false,
      errors: new Errors()
    }
  },
  async created() {
    await Promise.all([this.fetchCorporatePartner()]).then(() => {
      this.model = this.value
      this.setEditData()
    })
  },
  computed: {
    ...mapState('studentProfile', ['coperatePathners', 'edit_data']),
    corporatePartnerOptions() {
      return this.coperatePathners.map(el => ({
        value: el.cpp_id,
        text: el.partner_name_en + '|' + el.partner_name_kh
      }))
    }
  },
  methods: {
    ...mapActions('studentProfile', ['fetchCorporatePartner']),
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        ;(this.model.student_id = this.edit_data.student_id),
          (this.model.is_card_discount = this.edit_data.is_card_discount),
          (this.model.is_till_further_notice = this.edit_data.is_till_further_notice),
          (this.model.card_discount_rate = this.edit_data.card_discount_rate),
          (this.model.discount_expiry_date = this.edit_data.discount_expiry_date),
          (this.model.discount_note = this.edit_data.discount_note),
          (this.model.cpp_id = this.edit_data.cpp_id)
      }
    }
  },
  watch: {
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    },
    'model.is_card_discount': function(isCardDiscount) {
      if (!isCardDiscount) {
        this.model.is_till_further_notice = false
        this.model.card_discount_rate = ''
        this.model.discount_expiry_date = ''
        this.model.discount_note = ''
      }
    },
    'model.is_till_further_notice': function(isTillFurtherNotice) {
      if (this.model.is_card_discount && isTillFurtherNotice) {
        this.model.discount_expiry_date = ''
      }
    },
    clear: function(value) {
      if (value == true) {
        this.model = this.value
      }
    }
  }
}
</script>
